export const getReferralLink = (baseUrl: string | undefined, referralCode: string | null) => {
  if (!baseUrl || !referralCode) return null;

  try {
    const referralUrl = new URL('/auth/sign-up', baseUrl);
    referralUrl.searchParams.set('referral_code', referralCode);

    return referralUrl.toString();
  } catch {
    return null;
  }
};
